import { defineColumns } from '@juvare/platform-shared/features/storage';
export const columns = defineColumns({
    id: {
        type: 'id-required',
    },
    name: {
        type: 'string-required',
    },
    status: {
        type: 'string',
    },
    lastUpdatedAt: {
        type: 'number',
    },
    lastCheckedAt: {
        type: 'number',
    },
    lastSuccessAt: {
        type: 'number',
    },
    calculateAge: {
        type: 'boolean',
    },
});
